import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MapPinOff } from 'lucide-react';

/**
 * A page that says it isn't there.
 *
 * The crew app used to answer every unknown /crew/... path by silently
 * redirecting to the dashboard, so a dead link (or a typo, or a stale
 * bookmark like /crew/availability) looked exactly like a working one that
 * happened to land on the dashboard — nobody could tell a missing feature
 * from a broken one. Say so instead, and offer the way back.
 */
export default function NotFound({ home = '/dashboard', homeLabel = 'Go to Dashboard' }: { home?: string; homeLabel?: string }) {
  const { pathname } = useLocation();
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6 py-12">
      <MapPinOff className="h-10 w-10 text-gray-300 mb-3" />
      <h1 className="text-2xl font-black uppercase tracking-tight text-gray-900">Page not found</h1>
      <p className="mt-1 text-sm text-gray-500">
        Nothing lives at <code className="px-1.5 py-0.5 rounded bg-gray-100 text-gray-700 break-all">{pathname}</code>.
      </p>
      <Link to={home} className="btn-primary text-sm mt-5">{homeLabel}</Link>
    </div>
  );
}
